import {
  React,
  useLocation,
  TemplateOne,
  TemplateTwo,
  TemplateThree,
  TemplateFour,
  TemplateFive,
  TemplateSix,
  Empty,
} from "../../../Libraries/Post/LayoutPreview/index";

const LayoutPreview = () => {
  const { state } = useLocation();

  console.log("Test screen" + JSON.stringify(state));
  return (
    <>
        {/* <TemplateTwo /> */}

      {state?.ser_layout_id === "1" ? (
        <TemplateOne />
      ) : state?.ser_layout_id === "2" ? (
        <TemplateTwo />
      ) : state?.ser_layout_id === "3" ? (
        <TemplateThree />
      ) : state?.ser_layout_id === "4" ? (
        <TemplateFour />
      ) : state?.ser_layout_id === "5" ? (
        <TemplateFive />
      ) : state?.ser_layout_id === "6" ? (
        <TemplateSix />
      ) : (
        <Empty />
      )}
    </>
  );
};

export default LayoutPreview;
